





























import { Vue, Component, Emit, Ref, Prop } from 'vue-property-decorator'
import { BrowserQRCodeReader, Result } from '@zxing/library'
import { getID, getPositionAndTotal } from '@/utils/qr'

type VideoSource = {
  label: string
  id: string
}

type ScanMode = 'single' | 'multi'

@Component
export default class QR2 extends Vue {
  reader = new BrowserQRCodeReader()
  videoSources = [] as VideoSource[]
  selectedVideoSourse = ''
  mode: ScanMode = 'single'
  qrID: number | undefined = undefined
  total = 1
  results = [] as Result[]

  @Emit('total')
  totalEmit(): number {
    return this.total
  }

  @Emit('done')
  doneEmit(): boolean[] {
    return this.results.map(v => !!v)
  }

  get videoConstrains(): MediaTrackConstraints {
    // if (this.selectedVideoSourse) {
    //   return {
    //     deviceId: { exact: this.selectedVideoSourse },
    //     width: this.size.width,
    //     height: this.size.height
    //   }
    // }
    return {
      facingMode: 'environment',
      width: this.size.width,
      height: this.size.height
    }
  }

  created() {
    this.reader
      .getVideoInputDevices()
      .then(devices => {
        if (devices.length === 0) {
          this.handleError('カメラを起動できませんでした。')
        } else {
          this.selectedVideoSourse = devices[0].deviceId
          this.videoSources = devices.map(device => ({
            label: device.label,
            id: device.deviceId
          }))
        }
      })
      .then(() => {
        this.startScan()
      })
  }

  @Ref('qr') qr!: HTMLCanvasElement
  @Ref('video') video!: HTMLVideoElement
  @Prop({ default: () => ({ width: 300, height: 300 }) }) size!: {
    width: number
    height: number
  }

  reset() {
    this.mode = 'single'
    this.qrID = undefined
    this.total = 1
    this.results = []
    this.totalEmit()
    this.doneEmit()
  }

  startScan() {
    this.reader.decodeFromConstraints(
      { video: this.videoConstrains },
      'qr-caputure',
      res => {
        const ctx = this.qr.getContext('2d')
        if (ctx) {
          ctx.clearRect(0, 0, this.size.width, this.size.height)
          ctx.drawImage(this.video, 0, 0, this.size.width, this.size.height)
        }
        if (res) {
          if (ctx) {
            ctx.strokeStyle = 'red'
            ctx.lineWidth = 5
            const pos = res.getResultPoints()
            ctx.beginPath()
            ctx.moveTo(pos[0].getX(), pos[0].getY())
            ctx.lineTo(pos[1].getX(), pos[1].getY())
            ctx.lineTo(pos[2].getX(), pos[2].getY())
            ctx.lineTo(pos[3].getX(), pos[3].getY())
            ctx.lineTo(pos[0].getX(), pos[0].getY())
            ctx.stroke()
          }
          this.handleResult(res)
        }
      }
    )
    // this.reader.decodeFromInputVideoDeviceContinuously(
    //   this.selectedVideoSourse,
    //   'qr-caputure',
    //   res => {
    //     const ctx = this.qr.getContext('2d')
    //     if (ctx) {
    //       ctx.clearRect(0, 0, this.size.width, this.size.height)
    //       ctx.drawImage(this.video, 0, 0)
    //     }
    //     if (res) {
    //       if (ctx) {
    //         ctx.strokeStyle = 'red'
    //         ctx.lineWidth = 5
    //         const pos = res.getResultPoints()
    //         ctx.beginPath()
    //         ctx.moveTo(pos[0].getX(), pos[0].getY())
    //         ctx.lineTo(pos[1].getX(), pos[1].getY())
    //         ctx.lineTo(pos[2].getX(), pos[2].getY())
    //         ctx.lineTo(pos[3].getX(), pos[3].getY())
    //         ctx.lineTo(pos[0].getX(), pos[0].getY())
    //         ctx.stroke()
    //       }
    //       this.handleResult(res)
    //     }
    //   }
    // )
    // this.reader
    //   .decodeFromInputVideoDevice(this.selectedVideoSourse, 'qr-caputure')
    //   .then(res => {
    //     if (res) {
    //       this.handleResult(res)
    //     }
    //   })
  }

  @Emit()
  input(): string {
    const data = this.results.map(res => res.getText()).join('')
    return data
  }

  handleError(message: string) {
    this.reader.reset()
    this.reset()
    this.$emit('error', message)
  }

  handleResult(result: Result) {
    const id = getID(result)
    if (!id) {
      if (this.mode === 'multi') {
        this.handleError(
          '連続QRコードの読み取り中に別のQRコードを読み取りました'
        )
        this.reset()
        return
      }
      this.results = [result]
      this.input()
      this.reader.reset()
      this.reset()
    } else {
      const meta = getPositionAndTotal(result)
      if (!meta) {
        this.handleError('連続QRコードの内部データの読み取りに失敗しました。')
        return
      }
      if (this.mode === 'single') {
        this.total = meta.total
        this.results = []
        this.results.length = meta.total
        this.mode = 'multi'
        this.totalEmit()
      }
      if (!this.qrID) {
        this.qrID = id
      }
      if (this.qrID && this.qrID !== id) {
        this.handleError(
          '連続していないQRコードが検出されました。もう一度やり直してください。'
        )
        return
      }
      if (!this.results[meta.position - 1]) {
        this.$set(this.results, meta.position - 1, result)
        this.doneEmit()
        if (this.results.filter(v => v).length === this.total) {
          this.input()
          this.reader.reset()
          this.reset()
        }
      }
    }
  }
}
